<template>
  <div>
    <div class="sga-page-12 page-12">
      <h3>You're all done</h3>
      <p>
        Thank you for completing the survey. If you wish to learn more about
        what happens with your data,
        <router-link to="/sga/questionnaire/privacy">click here.</router-link>
      </p>

      <!-- <div class="qrcode-banner">
        <QRCodeCard
          :userId="currentUser.Id"
          :setToPublic="currentUser.ProfileIsPublic"
          :fromSettingPage="false"
          downloadStyle="margin-top:12px">
        </QRCodeCard>  
      </div> -->

      <div class="resume-banner">
        <el-row :gutter="5" style="height: 180px" class="vCard">
          <el-col
            :xl="16"
            :lg="16"
            :md="16"
            :sm="24"
            :xs="24"
            class="card-body card-desc"
          >
            <p style="text-align: left; color: black; font-weight: bold">
              Design your resume & Digital Business Card
            </p>
            <ul style="font-size: 14.4px">
              <li>Talentsensus generated a default resume for you</li>
              <li>
                Create new resume and select information you only want to share
              </li>
              <li>View and share your online business using your QR code</li>
              <li>
                You can do all this using our
                <el-button
                  type="text"
                  style="
                    text-decoration: none;
                    font-weight: 600;
                    color: #409eff;
                  "
                  @click="goToMyOnlineProfile"
                  >Resume Builder</el-button
                >
              </li>
            </ul>
          </el-col>
          <el-col
            :xl="8"
            :lg="8"
            :md="8"
            :sm="24"
            :xs="24"
            class="card-body card-img"
            style=""
          >
            <img
              src="../../../../assets/img/Resume.png"
              id="talent-sensus-icon"
              style="height: 200px; width 150px;"
            />
          </el-col>
        </el-row>
      </div>

      <div class="skillspassport-banner">
        <el-row :gutter="5" style="height: 180px" class="sCard">
          <el-col
            :xl="8"
            :lg="8"
            :md="8"
            :sm="24"
            :xs="24"
            class="card-body card-img"
            style=""
          >
            <img
              src="../../../../assets/img/Passport.png"
              id="talent-sensus-icon"
              style="height: 200px; width 150px;"
            />
          </el-col>
          <el-col
            :xl="16"
            :lg="16"
            :md="16"
            :sm="24"
            :xs="24"
            class="card-body card-desc"
          >
            <p style="text-align: left; color: black; font-weight: bold">
              Explore career options with Skills Passport
            </p>
            <ul style="font-size: 14.4px">
              <li>Learn more about new jobs or careers</li>
              <li>Explore your current job’s outlook and salaries</li>
              <li>Learn more about careers that are in demand</li>
              <li>
                Start exploring using our
                <el-button
                  type="text"
                  style="
                    text-decoration: none;
                    font-weight: 600;
                    color: #409eff;
                  "
                  @click="goToMySkillsPassport"
                  >Skills Passport</el-button
                >
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div
        class="workforce-banner"
        v-if="this.$store.state.account.current_user"
      >
        <el-row :gutter="5" style="height: 180px" class="wfCard">
          <el-col
            :xl="12"
            :lg="12"
            :md="12"
            :sm="24"
            :xs="24"
            class="card-body card-desc"
          >
            <p style="text-align: left; color: black; font-weight: bold">
              Connect to your local career center
            </p>
            <ul style="font-size: 14.4px">
              <li>See the list of Career Centers near you</li>
              <li>Manage your connected Career Centers and assigned staff</li>
              <li>Request staff re-assignment</li>
              <li>
                Get hired using
                <el-button
                  type="text"
                  style="
                    text-decoration: none;
                    font-weight: 600;
                    color: #409eff;
                  "
                  @click="goToAgencyDashboard"
                  >Career Center Dashboard</el-button
                >
              </li>
            </ul>
          </el-col>
          <el-col
            :xl="12"
            :lg="12"
            :md="12"
            :sm="24"
            :xs="24"
            class="card-body card-img"
            style=""
          >
            <img
              src="../../../../assets/img/Workforce.png"
              id="talent-sensus-icon"
              style="height: 200px; width 150px;"
            />
          </el-col>
        </el-row>
      </div>

      <p style="margin-top: 40px">
        Click the button below to finish and return to home page.
      </p>

      <div class="clearfix"></div>

      <button
        type="button"
        class="ts-btn ts-btn-rounded ts-btn-secondary"
        @click="submitSga()"
      >
        Finish
      </button>
    </div>
    <questionnaire-print
      ref="questionnaire"
      :page1="page1"
      :page2="page2"
      :page3="page3"
      :page4="page4"
      :page5="page5"
      :page6="page6"
      :page7="page7"
      :page8="page8"
      :page9="page9"
      :page10="page10"
      :page11="page11"
      currentPage="page12"
    >
    </questionnaire-print>
    <!-- <JobSeekerCV ref="cv" :Data="currentSga" :UserInfo="currentUser" :ShowProfile="showProfile"></JobSeekerCV> -->
    <JobSeekerCV
      ref="cv"
      :Data="profile.survey"
      :profile="profile"
      :Image="base64Raw"
      :UserInfo="currentUser"
      :ShowProfile="showProfile"
    ></JobSeekerCV>
    <ResumeListSelection
      :ProfileSettings="profileSettings"
      :ShowControl="showResumeListModal"
      @close-control="closeResumeListModal"
      @show-resume="displayResume"
    ></ResumeListSelection>
    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import Vue from "vue";
//use signalR
import * as signalR from "@aspnet/signalr";
import QuestionnairePrint from "../../components/QuestionnairePrint.vue";
import JobSeekerCV from "../../components/JobSeekerCV";
import QRCodeCard from "../../../../components/QRCodeCard.vue";
import TSLoading from "../../../../components/TSLoading.vue";
import ResumeListSelection from "../../components/ResumeListSelection.vue";

export default {
  components: {
    QuestionnairePrint,
    JobSeekerCV,
    QRCodeCard,
    TSLoading,
    ResumeListSelection
  },
  data() {
    return {
      showResumeListModal: false,
      isLoading: false,
      connection: "",
      huburl: "",
      sgaEmployeeInfo: {},
      sgaEducation: {
        secondLevelEducation: {
          highSchoolDiploma: false,
          ged: false,
          oLevels: false,
          oLevelDetails: [],
          leavingCert: false,
          aLevels: false,
          aLevelDetails: []
        },
        thirdLevelEducation: {
          associateDegree: false,
          associateDegreeDetails: [],
          bachelorsDegree: false,
          bachelorsDegreeDetails: []
        },
        fourthLevelEducation: {
          mastersDegree: false,
          mastersDegreeDetails: [],
          doctoralDegree: false,
          doctoralDegreeDetails: []
        },
        sectorExperience: {
          experience: false,
          experienceDetails: []
        },
        naicsLevel1Options: {}
      },
      sgaWorkHistory: {
        userWorkHistory: []
      },
      sgaHiddenExtras: {
        workingPracticeActivities: []
      },
      sgaKnowledge: {
        knowledgeRegularlyUsed: []
      },
      sgaMindset: {
        mindsets: []
      },
      sgaSkills: {
        workingPracticeSkills: []
      },
      sgaHiddenTalents: {
        skillsKnowledgeOutsideWork: []
      },
      sgaCulture: {
        selectedCultureOptions: [],
        commuteDistance: "",
        transportation: []
      },
      sgaCertifications: {
        userCertifications: []
      },
      cvCollection: [],
      showProfile: true,
      base64Raw: null,
      profile: {},
      profileSettings: []
    };
  },
  created() {
    this.$store.dispatch("sga/getsga");

    if (sessionStorage.getItem("profilephoto")) {
      this.base64Raw = sessionStorage.getItem("profilephoto");
    }
  },
  mounted() {
    this.$router.app.$on("questionnaire-print", this.printPage);
    // this.$router.app.$on('cv-print', this.printPageAsCV);
    this.$router.app.$on("show-resume-list", this.showResumeList);
  },
  destroyed() {
    if (
      this.$route.matched.find(c => c.path === "/sga/questionnaire") ===
      undefined
    ) {
      sessionStorage.removeItem("sgaDataForPrinting");
    } else {
      this.$router.app.$off("questionnaire-print", this.printPage);
      this.$router.app.$off("cv-print", this.printPageAsCV);
    }
  },
  computed: {
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    page1() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page1
        : {};
    },
    page2() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page2
        : {};
    },
    page3() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page3
        : {};
    },
    page4() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page4
        : {};
    },
    page5() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page5
        : {};
    },
    page6() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page6
        : {};
    },
    page7() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page7
        : {};
    },
    page8() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page8
        : {};
    },
    page9() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page9
        : {};
    },
    page10() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page10
        : {};
    },
    page11() {
      return sessionStorage.getItem("sgaDataForPrinting")
        ? JSON.parse(sessionStorage.getItem("sgaDataForPrinting")).page11
        : {};
    }
  },
  methods: {
    goToMySkillsPassport() {
      if (
        this.$store.state.account.current_user.state.account.current_user.roles.includes(
          "Apprentice"
        )
      ) {
        this.$router.push({ name: "ApprenticeSkillsPassport" });
      } else {
        this.$router.push({ path: "/js-skills-passport/landing" });
      }
    },
    goToMyOnlineProfile() {
      if (this.$store.state.account.current_user.roles.includes("Apprentice")) {
        this.$router.push({ name: "ApprenticeProfilePageSetting" });
      } else {
        this.$router.push({ name: "JobSeekerProfilePageSetting" });
      }
    },
    goToAgencyDashboard() {
      this.$router.push({ name: "agency-dashboard" });
    },
    closeResumeListModal() {
      this.showResumeListModal = false;
    },
    showResumeList() {
      this.$store
        .dispatch(
          "onlineprofile/getuserprofilepagesettings",
          this.currentUser.id
        )
        .then(res => {
          this.profileSettings = res.filter(d => d.isActive == true);
          this.loading = false;
          this.showResumeListModal = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    displayResume(setting) {
      var obj = {
        userid: this.currentUser.id,
        cvid: setting.id
      };
      this.$store
        .dispatch("account/getprofiledetails", obj)
        .then(res => {
          this.profile = res;
          this.showProfile = this.profile?.configuration?.profileConfiguration?.personalInformation?.profilePhoto;
          this.closeResumeListModal();

          this.$refs.cv.showCV(true);
          // this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            // action();
            window.print();
            x();
          }, 500);
        })
        .catch(res => {
          this.$refs.cv.showCV(true);
          // this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            // action();
            window.print();
            x();
          }, 500);
        });
    },
    submitSga() {
      this.isLoading = true;
      this.currentSga.isComplete = true;

      this.currentSga.isComplete = true;

      if (this.currentSga.sgaEmployeeInfo.id == null) {
        this.$store
          .dispatch("sga/postsga", this.currentSga)
          .then(res => {
            let test = this.currentUser;
            if (this.currentUser.roles[0] == "Apprentice")
              this.$router.push({ name: "apprentice-dashboard" });
            else {
              this.$store.dispatch("account/restore").then(() => {
                this.$router.push({ name: "jobseeker-dashboard" });
              });
            }
          })
          .catch(res => {
            this.modelState = res;
          })
          .finally(res => {
            this.isLoading = false;
          });
      } else {
        this.$store
          .dispatch("sga/putsga", this.currentSga)
          .then(res => {
            let test = this.currentUser;
            if (this.currentUser.roles[0] == "Apprentice")
              this.$router.push({ name: "apprentice-dashboard" });
            else {
              this.$store.dispatch("account/restore").then(() => {
                this.$router.push({ name: "jobseeker-dashboard" });
              });
            }
          })
          .catch(res => {
            this.modelState = res;
          })
          .finally(res => {
            this.isLoading = false;
          });
      }
    },
    printPage(action) {
      this.loadPages(action);
    },
    loadPages(action) {
      this.$store.dispatch("sga/getsga").then(data => {
        this.sgaYourJob = data.sgaYourJob || this.sgaYourJob;
        this.sgaEducation = data.sgaEducation || this.sgaEducation;
        this.sgaWorkHistory = data.sgaWorkHistory || this.sgaWorkHistory;
        this.sgaCertifications =
          data.sgaCertifications || this.sgaCertifications;
        this.sgaHiddenExtras = data.sgaHiddenExtras || this.sgaHiddenExtras;
        this.sgaKnowledge = data.sgaKnowledge || this.sgaKnowledge;
        this.sgaMindset = data.sgaMindset || this.sgaMindset;
        this.sgaSkills = data.sgaSkills || this.sgaSkills;
        this.sgaHiddenTalents = data.sgaHiddenTalents || this.sgaHiddenTalents;
        this.sgaCulture = data.culture || this.sgaCulture;
        this.$store
          .dispatch("sga/getSGAforPrint", this.currentSga.sgaHiddenExtras)
          .then(() => {
            this.$refs.cv.hideCV();
            this.$refs.questionnaire.showQuestionnaire();
            action();
            this.$refs.questionnaire.hideQuestionnaire();
          });
      });
    },
    printPageAsCV(action) {
      this.cvCollection = [
        {
          userInfo: this.currentUser,
          image: this.base64Raw,
          survey: this.currentSga
        }
      ];
      this.$confirm(`Do you want to include profile picture?`, "Warning", {
        confirmButtonText: "Yes",
        dangerouslyUseHTMLString: true,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        center: true
      })
        .then(() => {
          this.$refs.cv.showCV(true);
          this.showProfile = true;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
          //this.$refs.cv.hideCV();
        })
        .catch(() => {
          this.$refs.cv.showCV(false);
          this.showProfile = false;
          this.$refs.questionnaire.hideQuestionnaire();
          var x = this.$refs.cv.hideCV;
          window.setTimeout(function() {
            action();
            x();
          }, 500);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.qrcode-banner {
  height: 225px;
  width: 600px;
  background-color: rgb(179, 240, 255);
  padding: 10px;
  text-align: center;
  border-radius: 1%;
}

.resume-banner {
  background-color: rgb(179, 240, 255);
  padding: 30px;
  height: 250px;
  margin-bottom: 20px;
}

.skillspassport-banner {
  background-color: antiquewhite;
  padding: 30px;
  height: 250px;
  margin-bottom: 20px;
}

.workforce-banner {
  background-color: #50d0dd;
  padding: 30px;
  height: 250px;
  margin-bottom: 20px;
}

@media screen and (max-width: 759px) {
  .qrcode-banner {
    width: 100% !important;
    height: 100% !important;
  }

  .resume-banner,
  .skillspassport-banner,
  .workforce-banner {
    height: unset !important;
  }

  .vCard,
  .sCard,
  .wfCard {
    height: unset !important;
  }

  .card-img {
    text-align: center !important;
  }
}
</style>
